import React from 'react';

interface SortControlsProps {
    sortBy: string;
    sortDirection: string;
    onSortChange: (sortField: string, sortDirection: string) => void;
}

const SortControls: React.FC<SortControlsProps> = ({ sortBy, sortDirection, onSortChange }) => {
    const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const [sortField, direction] = event.target.value.split('|');
        onSortChange(sortField, direction);
    };

    return (
        <div className="list-group-item">
            <h4 className="kanit-regular">Sort by:</h4>
            <div className="form-check">
                <input
                    className="form-check-input"
                    type="radio"
                    name="sortOptions"
                    id="sortDateUpdatedDesc"
                    value="dateUpdated|desc"
                    checked={sortBy === 'dateUpdated' && sortDirection === 'desc'}
                    onChange={handleRadioChange}
                />
                <label className="form-check-label" htmlFor="sortDateUpdatedDesc">Recently Updated</label>
            </div>
            <div className="form-check">
                <input
                    className="form-check-input"
                    type="radio"
                    name="sortOptions"
                    id="sortDatePostedDesc"
                    value="datePosted|desc"
                    checked={sortBy === 'datePosted' && sortDirection === 'desc'}
                    onChange={handleRadioChange}
                />
                <label className="form-check-label" htmlFor="sortDatePostedDesc">Date Posted (New to Old)</label>
            </div>
            <div className="form-check">
                <input
                    className="form-check-input"
                    type="radio"
                    name="sortOptions"
                    id="sortDatePostedAsc"
                    value="datePosted|asc"
                    checked={sortBy === 'datePosted' && sortDirection === 'asc'}
                    onChange={handleRadioChange}
                />
                <label className="form-check-label" htmlFor="sortDatePostedAsc">Date Posted (Old to New)</label>
            </div>
        </div>
    );
};

export default SortControls;
